import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import ecosystem from './ecosystem'
import network from './network'
import company from './company'
import search from './search'
import patching from './patching'
import theme from './theme'

Vue.use(Vuex)

export const storeConfig = {
  modules: {
    user,
    ecosystem,
    network,
    company,
    search,
    patching,
    theme,
  },
}

export default new Vuex.Store(storeConfig)
